module.exports = __webpack_public_path__ + "static/media/Rectangle1.e78f3a06.webp";